import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { FaChevronRight, FaChevronLeft } from 'react-icons/fa';
import { FetchUser } from '../../../Redux/features/auth/authSlice';
import { useDispatch, useSelector } from 'react-redux';
import { API_URL, config } from '../../../config/config';
import { toast } from 'react-toastify';
import { useLocation, useNavigate } from 'react-router';
import FilterSectionForUser from './FilterSectionForUser';
import no_user_request from '../../images/no_userRequest.png';

const Skeleton = () => (
	<>
		{/* Skeleton Rows */}
		{[...Array(17)].map((_, index) => (
			<tr key={index} className='w-full animate-pulse border'>
				<td className='py-2 px-4'>
					<div className='md:h-6 h-4 bg-gray-300 rounded w-20 mx-auto'></div>
				</td>
				<td className='py-2 px-4'>
					<div className='md:h-6 h-4 bg-gray-300 rounded w-32 mx-auto'></div>
				</td>
				<td className='py-2 px-4'>
					<div className='md:h-6 h-4 bg-gray-300 rounded w-60 mx-auto'></div>
				</td>
				<td className='py-2 px-4'>
					<div className='md:h-6 h-4 bg-gray-300 rounded w-24 mx-auto'></div>
				</td>
				<td className='py-2 px-4'>
					<div className='md:h-6 h-4 bg-gray-300 rounded w-28 mx-auto'></div>
				</td>
				<td className='py-2 px-4'>
					<div className='md:h-6 h-4 bg-gray-300 rounded w-28 mx-auto'></div>
				</td>
				<td className='py-2 px-4'>
					<div className='md:h-6 h-4 bg-gray-300 rounded w-28 mx-auto'></div>
				</td>
				<td className='py-2 px-4'>
					<div className='md:h-6 h-4 bg-gray-300 rounded w-28 mx-auto'></div>
				</td>
			</tr>
		))}
	</>
);

const UserRequest = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const location = useLocation();
	const queryParams = new URLSearchParams(location.search);
	const pageFromUrl = queryParams.get('page');
	const initialPage = pageFromUrl ? parseInt(pageFromUrl, 10) : 1;
	const [isOpen, setIsOpen] = useState(false);
	const [toggleId, setToggleId] = useState(null);
	const [hasFetched, setHasFetched] = useState(false);
	const [toggleStatus, setToggleStatus] = useState(null);
	const { data, isLoading } = useSelector((state) => state.auth);
	const [currentPage, setCurrentPage] = useState(initialPage);
	const Users = data?.data;
	const totalPages = data?.totalPages;
	const [Filter, setFilter] = useState({
		MobileNo: '',
	});

	useEffect(() => {
		if (data.length === 0 && !isLoading && !hasFetched) {
			dispatch(FetchUser({ data: Filter, page: currentPage }));
			setHasFetched(true); // Prevent further fetches after the first load
		}
	}, [dispatch, data?.length, currentPage, isLoading, hasFetched, Filter]);

	const openModal = (id, IsApproved) => {
		setToggleId(id);
		setToggleStatus(IsApproved === '1' ? '0' : '1');
		setIsOpen(true);
	};

	const closeModal = () => setIsOpen(false);

	const handleNextPage = () => {
		if (currentPage < totalPages) {
			const page = currentPage + 1;
			setCurrentPage(page);
			dispatch(FetchUser({ data: Filter, page }));
			navigate(`/userrequest/?page=${page}`);
		}
	};

	const handlePrevPage = () => {
		if (currentPage > 1) {
			const page = currentPage - 1;
			setCurrentPage(page);
			dispatch(FetchUser({ data: Filter, page }));
			navigate(`/userrequest/?page=${page}`);
		}
	};
	// Handle page number click
	const handlePageNumberClick = (page) => {
		if (page === currentPage) return;
		setCurrentPage(page);
		dispatch(FetchUser({ data: Filter, page: page }));
		navigate(`/userrequest/?page=${page}`);
	};

	const generatePageNumbers = () => {
		const pages = [];
		const visiblePages = 3;

		if (totalPages <= visiblePages) {
			for (let i = 1; i <= totalPages; i++) {
				pages.push(i);
			}
		} else {
			pages.push(1);
			const startPage = Math.max(2, currentPage - 1);
			const endPage = Math.min(totalPages - 1, currentPage + 1);
			if (startPage > 2) {
				pages.push('...');
			}
			for (let i = startPage; i <= endPage; i++) {
				pages.push(i);
			}
			if (endPage < totalPages - 1) {
				pages.push('...');
			}
			pages.push(totalPages);
		}

		return pages;
	};
	const handleToggleDisplay = async (id, UserStatus) => {
		try {
			const response = await axios.post(
				`${API_URL}/Admin/ApproveUser`,
				{
					UserId: id,
					Value: UserStatus, // 1 or 0
				},
				config
			);

			if (response.data.success === true) {
				dispatch(FetchUser({ page: currentPage }));
				toast.success(`Product display status updated successfully!`);
			} else {
				toast.error('Failed to update display status.');
			}
		} catch (error) {
			console.error('Error toggling display status:', error);
			toast.error('Error toggling display status.');
		}
		closeModal();
	};

	const handleCheckboxChange = (id, IsApproved) => {
		openModal(id, IsApproved);
	};
	//   Calculate the paginated data to show on the current page
	// const currentPageData = data?.slice(
	//   (currentPage - 1) * rowsPerPage,
	//   currentPage * rowsPerPage
	// );
	// Filter the orders based on filter state
	const handleOrderFilter = () => {
		setCurrentPage(1);
		FetchUser(1);
		dispatch(FetchUser({ data: Filter, page: 1 }));
	};

	// Reset the filters
	const handleReset = () => {
		setFilter({
			MobileNo: '',
		});
		dispatch(FetchUser({ page: 1 }));
		setCurrentPage(1);
	};
	return (
		<>
			<div className='p-6 '>
				<FilterSectionForUser
					Filter={Filter}
					setFilter={setFilter}
					handleOrderFilter={handleOrderFilter}
					handleReset={handleReset}
				/>

				<div className='overflow-x-auto'>
					<table className='min-w-full bg-white table-auto lg:text-base text-sm max-[400px]:text-xs text-center'>
						<thead>
							<tr className='w-full bg-gray-100'>
								<th className='py-3 px-2 border-r'>Id</th>
								<th className='py-3 px-2 border-r'>Name</th>
								<th className='py-3 px-2 border-r'>FirmName</th>
								<th className='py-3 px-2 border-r'>Mobile Number</th>
								<th className='py-3 px-2 border-r'>GST Number</th>
								<th className='py-3 px-2 border-r'>Email Id</th>
								<th className='py-3 px-2 border-r'>Address</th>
								<th className='py-3 px-2 '>Status</th>
							</tr>
						</thead>
						<tbody>
							{isLoading ? (
								// Show skeleton rows while loading
								<>
									<Skeleton />
								</>
							) : (
								Users?.map((data, index) => (
									<tr key={index} className='border-t border-b'>
										<td className='py-3 px-2 border-r '>{data.Id}</td>
										<td className='py-3 px-2 border-r '>{data.Name}</td>
										<td className='py-3 px-2 border-r'>{data.FirmName}</td>
										<td className='py-3 px-2 border-r'>{data.MobileNo}</td>
										<td className='py-3 px-2 border-r'>{data.GSTNo}</td>
										<td className='py-3 px-2 border-r'>{data.UserEmail}</td>
										<td className='py-3 px-2 border-r'>{data.UserAddress}</td>
										<td className='py-3'>
											<label className='cursor-pointer flex items-center justify-center'>
												<input
													type='checkbox'
													checked={data.IsApproved === '1'}
													onChange={() => handleCheckboxChange(data.Id, data.IsApproved)}
													className='toggle-checkbox hidden'
												/>
												<span
													className={`toggle-label block w-8 h-4 rounded-full ${
														data.IsApproved === '1' ? 'bg-blue-500' : 'bg-gray-300'
													} relative`}>
													<span
														className={`absolute left-0 top-0 bg-white w-4 h-4 rounded-full transition-transform duration-300 ${
															data.IsApproved === '1' ? 'transform translate-x-4' : ''
														}`}
													/>
												</span>
												<span className='ml-2 text-xs font-medium'>
													{data.IsApproved === '1' ? 'Approve' : 'UnApprove'}
												</span>
											</label>
										</td>
									</tr>
								))
							)}
						</tbody>
					</table>
					{Users?.length === 0 && (
						<div className='flex flex-col justify-center items-center'>
							<img
								src={no_user_request}
								alt='Empty Cart'
								className='w-[350px] md:w-[600px] max-[330px]:w-[250px] mb-4'
							/>
						</div>
					)}
				</div>

				{/* Pagination controls */}
				<div className=' flex justify-center items-center gap-2  md:p-4 max-md:mt-4'>
					{currentPage > 1 && (
						<button
							onClick={handlePrevPage}
							className='px-2 py-2 border rounded bg-gray-200 hover:bg-gray-300 text-base'>
							<FaChevronLeft />
						</button>
					)}

					<div className='space-x-2'>
						{generatePageNumbers().map((page, index) =>
							typeof page === 'number' ? (
								<button
									key={index}
									onClick={() => handlePageNumberClick(page)}
									className={`px-3 py-1 border rounded text-base font-semibold ${
										page === currentPage
											? 'bg-[#EF4444] text-white'
											: 'bg-gray-200 hover:bg-gray-300'
									}`}>
									{page}
								</button>
							) : (
								<span key={index} className='text-gray-500'>
									...
								</span>
							)
						)}
					</div>

					{currentPage < totalPages && (
						<button
							onClick={handleNextPage}
							className='px-2 py-2 border rounded bg-gray-200 hover:bg-gray-300 text-base'>
							<FaChevronRight />
						</button>
					)}
				</div>
			</div>

			{isOpen && (
				<div className='fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center z-50'>
					<div className='bg-white p-4 sm:p-6 rounded-md w-full max-w-md mx-4 sm:w-[500px]'>
						<h2 className='text-lg sm:text-xl font-semibold mb-4'>Confirmation</h2>
						<p className='mb-6 text-sm sm:text-base'>
							Are you sure you want to change the toggle switch to{' '}
							<strong>{data[toggleId]?.IsApproved === '1' ? 'OFF' : 'ON'}</strong>?
						</p>
						<div className='flex justify-between'>
							<button
								onClick={closeModal}
								className='bg-gray-100 text-yellow-500 px-3 sm:px-4 py-2 rounded-md'>
								Cancel
							</button>
							<button
								onClick={() => handleToggleDisplay(toggleId, toggleStatus)}
								className='bg-red-500 text-white px-3 sm:px-4 py-2 rounded-md'>
								Confirm
							</button>
						</div>
					</div>
				</div>
			)}
		</>
	);
};

export default UserRequest;
